import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowVideoImageXlConverter extends CmsConverterService<PanelRowVideoImageXlData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_image_alternative_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      caption: formData.st_caption_text_small ?? defaultTextInput,
      captionOverlay: formData.st_caption_text_overlay ?? defaultTextInput,
      descriptionOverlay: formData.st_description_text_overlay ?? defaultTextInput,
      videoId: formData.st_video ?? '',
      image: CmsConverterService.mapImage(formData.st_image_normal_reference, lazyLoad, altText),
      spacing: {
        top: formData.st_spacing_top?.value?.identifier ?? '',
        bottom: formData.st_spacing_bottom?.value?.identifier ?? ''
      },
      captionEmpty: formData.st_caption_text_small_empty?.value ?? false
    }
  }
}

export const PANEL_ROW_VIDEO_IMAGE_XL_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowVideoImageXlData>>('PanelRowVideoImageXlConverter')

export interface PanelRowVideoImageXlData extends ConvertedComponentData {
  caption: TextInput;
  captionOverlay: TextInput;
  descriptionOverlay: TextInput;
  videoId: string;
  image: Image;
  spacing: Spacing;
  captionEmpty: boolean;
}
